module.exports = (value, toCompare) => value && value.includes(toCompare)
